// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on.
import { createFileRoute } from '@tanstack/react-router'
import { ResetPasswordScreen } from '../features/auth/ResetPasswordScreen'
import { text } from '../shared/routing/search'

export const Route = createFileRoute('/reset')({
  staticData: { screenId: 'AuthResetPasswordScreen', access: 'valid reset token' },
  // The route key's query arguments (screens.json `args`), as the apps' LinkResolver reads them;
  // unknown keys are dropped. A link without token cannot work: the screen shows its error state.
  validateSearch: (search: Record<string, unknown>): { token?: string } => ({
    token: text(search.token),
  }),
  component: AuthResetPasswordScreen,
})

function AuthResetPasswordScreen() {
  const { token } = Route.useSearch()
  return <ResetPasswordScreen token={token} />
}
